import { useContext, useEffect, useState } from "react";
import { AppContext } from "../../Context/MainContext";
import { formatCurrency } from "../../utils/number.utils";
import PaymentDocTableComponent from "../../Components/PaymentDocTable.component";

const GGDDPage = () => {

    const { transactions } = useContext(AppContext);
    const [data, setData] = useState<any[]>([]);

    useEffect(() => {
        if (transactions.length > 0) {
            let tmp = transactions.filter((transaction: any) => transaction.type === 'GGDD' && transaction.received === true);
            setData(tmp);
        }
    }, [transactions]);

    let columns = [
        { name: "Fecha", wrap: true, maxWidth: "10%", selector: (row: any) => new Date(row.date).toLocaleDateString(), sortable: true, sortFunction: (a: any, b: any) => new Date(a.date).getTime() - new Date(b.date).getTime() },
        { name: "Familia", wrap: true, maxWidth: "10%", selector: (row: any) => row.family, sortable: true },
        { wrap: true, maxWidth: "10%", name: <div>Hoja de control</div>, selector: (row: any) => row.controlSheet ? row.controlSheet.name : "", sortable: true },
        { wrap: true, maxWidth: "10%", name: <div>Factura</div>, selector: (row: any) => row.rawValue && row.rawValue.cabecera ? row.rawValue.cabecera.documento.numDocumento : row.externalID.split("-").slice(-1) },
        { wrap: true, maxWidth: "20%", name: <div>Proveedor</div>, selector: (row: any) => row.client, sortable: true },
        { wrap: true, maxWidth: "10%", name: <div>Descripción</div>, selector: (row: any) => row.description },
        { wrap: true, maxWidth: "10%", name: <div>Monto</div>, selector: (row: any) => `$${formatCurrency(row.total)}`, sortable: true, sortFunction: (a: any, b: any) => parseInt(a.total) - parseInt(b.total) },
        { wrap: true, maxWidth: "10%", name: <div>Estado</div>, selector: (row: any) => row.status },
        { wrap: true, maxWidth: "10%", name: <div>Estado de pago</div>, selector: (row: any) => row.paymentStatus },
    ];

    return (
        <PaymentDocTableComponent
            title="Guías de Despacho"
            data={data}
            columns={columns}
        />
    );
}

export default GGDDPage;